import { useSelector } from 'react-redux';
import {
  isYouTubeEnabledSelector,
  shareMethodOverridesSelector,
} from 'redux/modules/download';

export enum SocialIntegration {
  YOUTUBE = 'youtube',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  THREADS = 'threads',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  TIKTOK = 'tiktok',
  BLUESKY = 'bluesky',
  DIRECT_DOWNLOAD = 'directDownload',
}

export default function useSocialIntegration() {
  const isYouTubeEnabled = useSelector(isYouTubeEnabledSelector);
  const shareMethodOverrides = useSelector(shareMethodOverridesSelector);

  if (Array.isArray(shareMethodOverrides)) {
    return shareMethodOverrides;
  }

  return [
    SocialIntegration.TWITTER,
    SocialIntegration.FACEBOOK,
    isYouTubeEnabled && SocialIntegration.YOUTUBE,
    SocialIntegration.INSTAGRAM,
    SocialIntegration.THREADS,
    SocialIntegration.DIRECT_DOWNLOAD,
    SocialIntegration.LINKEDIN,
    SocialIntegration.TIKTOK,
    SocialIntegration.BLUESKY,
  ].filter(Boolean);
}
